import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';
import ProfileSuccessPage from '@/features/resume-builder/profile-success';

/**
 * DEV-483 — `Success` do fluxo pelo perfil. O `_` em `curriculo_` deixa a tela
 * FORA da layout do fluxo (como `/modulos/conclusao` fica fora da etapa): sem
 * aviso de saída, sem rodapé do fluxo.
 */
export const Route = createFileRoute('/perfil/curriculo_/sucesso')({
  component: () => (
    <HomeGate>
      <ProfileSuccessPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
